import {  Divider, Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import './ccf-divider-with-text.module.scss';

/* eslint-disable-next-line */
export interface CcfDividerWithTextProps {
  children?: React.ReactNode
}

const useStyles = makeStyles((theme : Theme) =>
  createStyles({
    root: {
      marginTop: 8,
      textAlign: 'center',
      fontSize: theme.typography.caption.fontSize,
      color: theme.palette.text.secondary,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      '& > hr': {
        minWidth: '25%',
        flex: 1,
      },
      '& > span': {
        maxWidth: '50%',
        marginInline: 4
      },
    },
  })
);

/**
 * Component used to display divider with text
 * @param props - CcfDividerWithTextProps
 * @example <CcfDividerWithText />
 * @returns divider with text
 */
export function CcfDividerWithText(props: CcfDividerWithTextProps) {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <Divider />
      <span>{props.children}</span>
      <Divider />
    </div>
  );
}

export default CcfDividerWithText;
